
export const admin = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: []
}
